module.exports = __webpack_public_path__ + "img/ar03.d54a5861.jpg";